/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import AccountRolesAPI from '../../api/accountRoles';
import { throwErrorMessage } from '../utils/api';

export const SET_ACCOUNT_ROLES_UI_FLAG = 'SET_ACCOUNT_ROLES_UI_FLAG';
export const SET_ACCOUNT_ROLES = 'SET_ACCOUNT_ROLES';
export const ADD_ACCOUNT_ROLE = 'ADD_ACCOUNT_ROLE';
export const EDIT_ACCOUNT_ROLE = 'EDIT_ACCOUNT_ROLE';
export const DELETE_ACCOUNT_ROLE = 'DELETE_ACCOUNT_ROLE';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAccountRoles($state) {
    return $state.records;
  },
  getAccountRole: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(SET_ACCOUNT_ROLES_UI_FLAG, { isFetching: true });
    try {
      const response = await AccountRolesAPI.get();
      commit(SET_ACCOUNT_ROLES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(SET_ACCOUNT_ROLES_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, roleObj) => {
    commit(SET_ACCOUNT_ROLES_UI_FLAG, { isCreating: true });
    try {
      const response = await AccountRolesAPI.create(roleObj);
      commit(ADD_ACCOUNT_ROLE, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(SET_ACCOUNT_ROLES_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(SET_ACCOUNT_ROLES_UI_FLAG, { isUpdating: true });
    try {
      const response = await AccountRolesAPI.update(id, updateObj);
      commit(EDIT_ACCOUNT_ROLE, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(SET_ACCOUNT_ROLES_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(SET_ACCOUNT_ROLES_UI_FLAG, { isDeleting: true });
    try {
      await AccountRolesAPI.delete(id);
      commit(DELETE_ACCOUNT_ROLE, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(SET_ACCOUNT_ROLES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [SET_ACCOUNT_ROLES_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [SET_ACCOUNT_ROLES]: MutationHelpers.set,
  [ADD_ACCOUNT_ROLE]: MutationHelpers.setSingleRecord,
  [EDIT_ACCOUNT_ROLE]: MutationHelpers.update,
  [DELETE_ACCOUNT_ROLE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
